export default __webpack_public_path__ + "static/media/loader.6ec33819.gif";